//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import api from "@/api"
export default {
    name: 'HeaderView',
    props:['headerActive','WorkName'],
    data () {
        return {
            dialogVisible2:false,
            getWorkName:'',
            collapse:false,
            Word:'',
            activeIndex:'',
            dialogVisible: false,
            activeStr:'UserCenter',
            navList:[
                {'name':'在线缴费',id:'years',class:'nav-1',dlb:'years'},
                {'name':'我的课程',id:'index',class:'nav-1',dlb:'index'},
                {'name':'在线考试',id:'exam',class:'nav-2',dlb:'exam'},
               
                {'name':'学分查询',id:'credit',class:'nav-2',dlb:'credit'},
                // {'name':'我的订单',id:'orders',class:'nav-2',dlb:'orders'},
                {'name':'电子发票',id:'invoice',class:'nav-2',dlb:'invoice'},
               
            ],
            str:''
        }
    },
    created(){
        this.getWorkName = window.localStorage.getItem('WorkName')
        this.activeIndex = this.headerActive
    },
    methods:{
        wjdcClick () {
            // window.open('/wjdc?dlb='+this.str)
            this.$router.push({name: 'wjdc',query:{dlb:this.str}})
        },
        password () {
            this.$router.push({name: 'resetpwd'})
        },
        goMessage (str) {
            this.$router.push({name: str})
        },
        LinkUrl (str) {
            this.$confirm('您确定退出吗？')
            .then(_ => {
                this.axios.post(api.LoginOut).then((res)=>{
                    window.localStorage.clear()
                    this.$router.push({name: 'login'})
                })
            })
        },
        navClick (c,dlb) {
            if (dlb == 'years') {
                this.$router.push({name: 'years'})
            }  else if (dlb == 'exam' || dlb == 'credit' ) {
                this.axios.get(api.ExamIsQ).then((res) =>{
                    if (res.data.code == 200) {
                        if (res.data.res.isq) { //要填写调查问卷
                            this.str = dlb
                            this.dialogVisible2 = res.data.res.isq
                        } else { // 不用填写
                            this.$router.push({name: c,params:{id:dlb}})
                        }
                    }
                })
            } else {
                this.$router.push({name: c,params:{id:dlb}})
            }
             //判断是否显示调查问卷
      
            
           
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
            .then(_ => {
                done();
            })
            .catch(_ => {});
        },
    },
}



// WEBPACK FOOTER //
// ./src/components/NavView.vue